import { render, staticRenderFns } from "./multipleSelect.vue?vue&type=template&id=10c3d012&scoped=true&"
import script from "./multipleSelect.vue?vue&type=script&lang=ts&"
export * from "./multipleSelect.vue?vue&type=script&lang=ts&"
import style0 from "./multipleSelect.vue?vue&type=style&index=0&id=10c3d012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3d012",
  null
  
)

export default component.exports